<div class="messages" data-testid="ai-agent-messages">
  @for (message of service.messages(); track message.id; let last = $last) {
    <soft-ds-chat-bubble [variant]="message.role">
      @if (message.role === 'user') {
        <span class="user-text">{{ message.text }}</span>
      } @else {
        <soft-ai-agent-message [message]="message" />
      }
    </soft-ds-chat-bubble>

    @if (
      last &&
      message.role === 'assistant' &&
      !service.isRunning() &&
      message.followups?.length
    ) {
      <soft-ds-button-group
        layout="spaced"
        overflow="wrap"
        size="sm"
        data-testid="ai-agent-followups"
      >
        @for (prompt of message.followups; track prompt) {
          <soft-ds-button variant="outline" (click)="sendFollowup(prompt)">
            {{ prompt }}
          </soft-ds-button>
        }
      </soft-ds-button-group>
    }
  } @empty {
    <p class="ds-body-2 empty">{{ '#AI_AGENT.EMPTY' | translate }}</p>
  }

  @if (service.error(); as error) {
    <p class="error ds-body-2" data-testid="ai-agent-error">
      {{ '#AI_AGENT.ERROR' | translate }} {{ error | translate }}
    </p>
  }
</div>

@if (context.chips(); as chips) {
  @if (chips.length > 0) {
    <div class="context-chips" data-testid="ai-agent-context-chips">
      @for (chip of chips; track chip.id) {
        <soft-ds-chip
          size="sm"
          variant="secondary"
          removable
          leadingIcon="fa-regular fa-location-crosshairs"
          (remove)="context.exclude(chip.id)"
        >
          {{ chip.label }}
        </soft-ds-chip>
      }
    </div>
  }
}

<soft-ai-agent-composer
  [disabled]="service.isRunning()"
  [compact]="compact()"
  (submitted)="submit($event)"
/>
